
import * as _asset0 from "inline-asset:assets/galleries/ua-2021-12-09/L1000941-color_dab579dd3f__13.jpg";
import * as _asset1 from "asset:assets/galleries/ua-2021-12-09/L1000941-color_dab579dd3f__264.jpg";
import * as _asset2 from "asset:assets/galleries/ua-2021-12-09/L1000941-color_dab579dd3f__529.jpg";
import * as _asset3 from "asset:assets/galleries/ua-2021-12-09/L1000941-color_dab579dd3f__1058.jpg";


export default {
  id: "L1000941-color",
  aspect: 0.661229792147806,
  alt: undefined,
  sources: [{
              url: _asset0.url,
              width: 13,
            },{
              url: _asset1.url,
              width: 264,
            },{
              url: _asset2.url,
              width: 529,
            },{
              url: _asset3.url,
              width: 1058,
            }],
};
        